import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';
import { ListItem } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import StyledListItemButton from './StyledComponents/StyledListItemButton';
import StyledListItemText from './StyledComponents/StyledListItemText';

const MenuOption = ({
    Icon,
    disabled,
    drawerSize,
    handleDrawerToggle,
    id,
    listItemClassName,
    mobileOpen,
    onClick,
    selected,
    setOpenDrawer,
    size = 'normal',
    title,
    to,
}) => {
    const handleOnClick = () => {
        if (onClick) {
            onClick();
            return;
        }
        if (mobileOpen && handleDrawerToggle) handleDrawerToggle();
        if (setOpenDrawer) setOpenDrawer(false);
    };

    return (
        <ListItem className={listItemClassName} disablePadding>
            <StyledListItemButton
                component={RouterLink}
                disabled={disabled}
                drawersize={drawerSize}
                id={id || `sidebar-${to.substring(1)}`}
                onClick={handleOnClick}
                selected={selected}
                to={to}
            >
                {Icon && (
                    <SvgIcon>
                        <Icon />
                    </SvgIcon>
                )}
                <StyledListItemText primary={title} size={size} />
            </StyledListItemButton>
        </ListItem>
    );
};

MenuOption.propTypes = {
    disabled: PropTypes.bool,
    drawerSize: PropTypes.string,
    handleDrawerToggle: PropTypes.func,
    Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    id: PropTypes.string,
    listItemClassName: PropTypes.string,
    mobileOpen: PropTypes.bool,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    setOpenDrawer: PropTypes.func,
    size: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    to: PropTypes.string,
};

export default MenuOption;
